import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CachedHttpService {

    private cache = new Map<string, Observable<any>>();

    constructor(private http: HttpClient) { }

    get<T>(url: string): Observable<T> {

        if (this.cache.has(url)) {
            return this.cache.get(url)!;
        }
        const request$ = this.http.get<T>(url).pipe(
            shareReplay(1)
        );
        this.cache.set(url, request$);
        return request$;
    }

    refresh<T>(url: string): Observable<T> {
        const request$ = this.http.get<T>(url).pipe(
            shareReplay(1)
        );
        this.cache.set(url, request$);
        return request$;
    }

    clear(url: string) {
        this.cache.delete(url);
    }

    clearAll() {
        this.cache.clear();
    }
}
